module.exports = {
    defaultLang: 'en-us',
    langs: [
        { value: 'en-us', prefix: 'en' },
        { value: 'de-de', prefix: 'de' },
    ],
};
